export function formatUSCurrency(
  number: number,
  options?: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  }
): string {
  let formatted = "";

  try {
    if (!options) options = {};
    if (options?.minimumFractionDigits === undefined) {
      options.minimumFractionDigits = 2;
    }
    if (options?.maximumFractionDigits === undefined) {
      options.maximumFractionDigits = options?.minimumFractionDigits;
    }

    formatted = number?.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: options?.maximumFractionDigits,
      minimumFractionDigits: options?.minimumFractionDigits,
      ...options,
    });

    // adding a little space between the dollar sign and the number
    formatted = formatted.replace("$", "$\u200A");
  } catch (error) {
    console.log("error formatting currency");
    console.log("error", error);
  } finally {
    return formatted;
  }
}

/**
 * Formats a raw amount with en-US thousands separators, without a currency
 * symbol — for call sites that already render their own "$".
 *
 * @param fractionDigits fixed number of decimals. Omit to keep the amount as
 * authored (no trailing ".00" on whole dollars, up to 2 decimals otherwise).
 */
export function formatAmount(number: number, fractionDigits?: number): string {
  return (number ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits ?? 0,
    maximumFractionDigits: fractionDigits ?? 2,
  });
}
